// CustomPlaceholder.js
import { Node, mergeAttributes } from '@tiptap/core'
import { NodeSelection } from '@tiptap/pm/state'

export const CustomPlaceholder = Node.create({
    name: 'customPlaceholder',

    group: 'inline',
    inline: true,
    selectable: true,
    atom: true,

    addAttributes() {
        return {
            value: {
                default: '',
            },
        }
    },

    parseHTML() {
        return [
            {
                tag: 'span[data-custom-placeholder]',
            },
        ]
    },

    renderHTML({ node, HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, {
                'data-custom-placeholder': '',
                class: 'custom-placeholder'
            }),
            node.attrs.value,
        ]
    },

    addNodeView() {
        return ({ node, getPos, editor }) => {
            const dom = document.createElement('span')
            dom.classList.add('custom-placeholder')
            dom.setAttribute('data-custom-placeholder', '')
            dom.textContent = node.attrs.value

            dom.addEventListener('click', (event) => {
                event.preventDefault()
                const pos = getPos()
                if (typeof pos === 'number') {
                    const { state, view } = editor
                    const tr = state.tr.setSelection(NodeSelection.create(state.doc, pos))
                    view.dispatch(tr)
                }
            })

            return {
                dom,
                contentDOM: null,
            }
        }
    },
})
